import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import {Box} from "@mui/material";

const LinearLoader = () => {
    return (
        <Box sx={{width: '100%'}}>
            <LinearProgress sx={{
                backgroundColor: 'rgba(64, 91, 216, 0.5)',
                '& .MuiLinearProgress-bar': {
                    backgroundColor: '#405BD8'
                }
            }}
            />
        </Box>
    );
};

export default LinearLoader;
